// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rightPanel_Xg6wL {
    display: flex;
    flex-direction: column;
    gap: 16px;
    /* position: sticky; */
    width: 100%;
    top: 20px;
    height: fit-content;
    align-self: flex-start;
}

.chartCard_yX9ZC {
    background: var(--white-background);
    /* border: 1px solid #e2e8f0; */
    border-radius: 12px;
    padding: 10px;
    /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
}

.chartHeader_x_Jkr {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    /* margin-bottom: 20px; */
}



.chartTitle_ajMyQ {
    font-size: 18px;
    font-weight: 700;
    color: var(--1e293b-color);
    margin-bottom: 4px;
    margin-top: 0px;
}

.chartSubtitle_tIJN6 {
    color: #727272;

    font-size: 16px;
    font-weight: 600;

    button {
        color: #0000004D
;
        background: none;
        border: none;
        cursor: pointer;
        font-size: 16px;
        font-weight: 600;
        &.active_GZD2v {
            color: var(--black-color);
        }
    }

}

.chartControls_diT4j {
    font-size: 12px;
    color: var(--64748b-color);
    display: flex;
    align-items: center;
    gap: 8px;
}


.chartValue_zy07L {
    font-size: 32px;
    font-weight: 800;
    margin-bottom: 20px;
    color: var(--1e293b-color);
}


.barChart_E90x0 {
    display: flex;
    align-items: end;
    height: 120px;
    gap: 8px;
    margin-bottom: 8px;
}


.bar_Ilctk {
    flex: 1 1;
    background: var(--10b981-background);
    border-radius: 3px 3px 0 0;
    min-height: 12px;
    transition: all 0.2s ease;
}

.bar_Ilctk:hover {
    background: var(--059669-background);
    transform: scaleY(1.05);
}

.bar_Ilctk:nth-child(2n) {
    background: #D9D9D9;
}

.chartLabels_yTwfA {
    display: flex;
    justify-content: space-between;
    font-size: 11px;
    color: var(--64748b-color);
    font-weight: 500;
    gap:10px;
}

.sectionHeader_M0KIS {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0px;
}


.newPanelBtn_migqH {
    border: 1px solid #cccccc;
    background: none;
    color: var(--black-color);
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 12px;
    border-radius: 30px;
    transition: all 0.2s ease;

    svg {
        width: 24px;
        height: 24px;
    }
}

.newPanelBtn_migqH:hover {
    background: var(--f0fdfa-background);
}


.chatPanel_s68kQ {
    text-align: center;
    background-color: var(--f4-background);
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 0px;
    padding: 12px;
}



.chatDescription_Mo0Dc {
    font-size: 14px;

    color: var(--64748b-color);
    margin-bottom: 16px;

    font-weight: 500;
}

.chatButton_aDjSL {
    width: 100%;
    padding: 10px 20px;
    background: linear-gradient(135deg, var(--10b981-background) 0%, var(--059669-background) 100%);
    color: var(--white-background);
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    svg {
        width: 24px;
        height: 24px;
    }
}

.chatButton_aDjSL:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px var(--green-12003-shadow);
}

.mediaControls_hchKr {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px;


}

.mediaBtn_FA_rN {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    color: var(--white-background);
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px var(--_0000001a-shadow);

    svg {
        width: 22px;
        height: 22px;
    }
    &.pause_uNUyZ {
        svg {
            width: 32px;
            height: 32px;
        }
    }
}

.mediaBtn_FA_rN:hover {
    transform: scale(1.05);
}

.mediaBtn_FA_rN.play_lBvic {

    background: linear-gradient(135deg, var(--10b981-background) 0%, var(--059669-background) 100%);
}

.mediaBtn_FA_rN.pause_uNUyZ {
    background: linear-gradient(135deg, var(--3b82f6-background) 0%, var(--1d4ed8-background) 100%);
}

.mediaBtn_FA_rN.stop_OMxTu {
    background: linear-gradient(135deg, var(--ef4444-color) 0%, var(--dc2626-color) 100%);

}



.timerDisplay_uuXb7 {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 80px;
    padding: 8px 12px;
    border-radius: 8px;
    font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.2s ease;
}

.timerDisplay_uuXb7.playing_roalm {
    background: var(--f0fdfa-background);
    color: var(--059669-background);
}

.timerDisplay_uuXb7.paused_R7jx7 {
    background: var(--fef2f2-background);
    color: var(--dc2626-color);
}

.timeHour_KHTY8 {
    font-size: 16px;
    font-weight: 700;
}

.month_HDCq1{
    display: flex;
    flex:1 1  
}




@media (max-width: 1000px) {
    .mainGrid_ieQGf {
        padding: 10px;
    }
    .chartHeader_x_Jkr {
        flex-direction: column;
        gap: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/DashboardComponents/Main/RightPanel/RightPanel.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sBAAsB;IACtB,WAAW;IACX,SAAS;IACT,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,yBAAyB;AAC7B;;;;AAIA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;;IAEd,eAAe;IACf,gBAAgB;;IAEhB;QACI;AACR;QACQ,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB;YACI,yBAAyB;QAC7B;IACJ;;AAEJ;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;;AAGA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;AAC9B;;;AAGA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;;;AAGA;IACI,SAAO;IACP,oCAAoC;IACpC,0BAA0B;IAC1B,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;;AAGA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;;IAEzB;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,oCAAoC;AACxC;;;AAGA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,aAAa;AACjB;;;;AAIA;IACI,eAAe;;IAEf,0BAA0B;IAC1B,mBAAmB;;IAEnB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,+FAA+F;IAC/F,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;IACT,aAAa;;;AAGjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,8BAA8B;IAC9B,yBAAyB;IACzB,6CAA6C;;IAE7C;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI;YACI,WAAW;YACX,YAAY;QAChB;IACJ;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,+FAA+F;AACnG;;AAEA;IACI,+FAA+F;AACnG;;AAEA;IACI,qFAAqF;;AAEzF;;;;AAIA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,yEAAyE;IACzE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;IACpC,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb;AACJ;;;;;AAKA;IACI;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ","sourcesContent":[".rightPanel {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    /* position: sticky; */\n    width: 100%;\n    top: 20px;\n    height: fit-content;\n    align-self: flex-start;\n}\n\n.chartCard {\n    background: var(--white-background);\n    /* border: 1px solid #e2e8f0; */\n    border-radius: 12px;\n    padding: 10px;\n    /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */\n}\n\n.chartHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    /* margin-bottom: 20px; */\n}\n\n\n\n.chartTitle {\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--1e293b-color);\n    margin-bottom: 4px;\n    margin-top: 0px;\n}\n\n.chartSubtitle {\n    color: #727272;\n\n    font-size: 16px;\n    font-weight: 600;\n\n    button {\n        color: #0000004D\n;\n        background: none;\n        border: none;\n        cursor: pointer;\n        font-size: 16px;\n        font-weight: 600;\n        &.active {\n            color: var(--black-color);\n        }\n    }\n\n}\n\n.chartControls {\n    font-size: 12px;\n    color: var(--64748b-color);\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n\n.chartValue {\n    font-size: 32px;\n    font-weight: 800;\n    margin-bottom: 20px;\n    color: var(--1e293b-color);\n}\n\n\n.barChart {\n    display: flex;\n    align-items: end;\n    height: 120px;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n\n.bar {\n    flex: 1;\n    background: var(--10b981-background);\n    border-radius: 3px 3px 0 0;\n    min-height: 12px;\n    transition: all 0.2s ease;\n}\n\n.bar:hover {\n    background: var(--059669-background);\n    transform: scaleY(1.05);\n}\n\n.bar:nth-child(2n) {\n    background: #D9D9D9;\n}\n\n.chartLabels {\n    display: flex;\n    justify-content: space-between;\n    font-size: 11px;\n    color: var(--64748b-color);\n    font-weight: 500;\n    gap:10px;\n}\n\n.sectionHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0px;\n}\n\n\n.newPanelBtn {\n    border: 1px solid #cccccc;\n    background: none;\n    color: var(--black-color);\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 500;\n    padding: 8px 12px;\n    border-radius: 30px;\n    transition: all 0.2s ease;\n\n    svg {\n        width: 24px;\n        height: 24px;\n    }\n}\n\n.newPanelBtn:hover {\n    background: var(--f0fdfa-background);\n}\n\n\n.chatPanel {\n    text-align: center;\n    background-color: var(--f4-background);\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    gap: 0px;\n    padding: 12px;\n}\n\n\n\n.chatDescription {\n    font-size: 14px;\n\n    color: var(--64748b-color);\n    margin-bottom: 16px;\n\n    font-weight: 500;\n}\n\n.chatButton {\n    width: 100%;\n    padding: 10px 20px;\n    background: linear-gradient(135deg, var(--10b981-background) 0%, var(--059669-background) 100%);\n    color: var(--white-background);\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n\n    svg {\n        width: 24px;\n        height: 24px;\n    }\n}\n\n.chatButton:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px var(--green-12003-shadow);\n}\n\n.mediaControls {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 12px;\n    padding: 16px;\n\n\n}\n\n.mediaBtn {\n    width: 54px;\n    height: 54px;\n    border-radius: 50%;\n    border: none;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    color: var(--white-background);\n    transition: all 0.2s ease;\n    box-shadow: 0 2px 4px var(--_0000001a-shadow);\n\n    svg {\n        width: 22px;\n        height: 22px;\n    }\n    &.pause {\n        svg {\n            width: 32px;\n            height: 32px;\n        }\n    }\n}\n\n.mediaBtn:hover {\n    transform: scale(1.05);\n}\n\n.mediaBtn.play {\n\n    background: linear-gradient(135deg, var(--10b981-background) 0%, var(--059669-background) 100%);\n}\n\n.mediaBtn.pause {\n    background: linear-gradient(135deg, var(--3b82f6-background) 0%, var(--1d4ed8-background) 100%);\n}\n\n.mediaBtn.stop {\n    background: linear-gradient(135deg, var(--ef4444-color) 0%, var(--dc2626-color) 100%);\n\n}\n\n\n\n.timerDisplay {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 80px;\n    padding: 8px 12px;\n    border-radius: 8px;\n    font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n    font-size: 14px;\n    font-weight: 600;\n    transition: all 0.2s ease;\n}\n\n.timerDisplay.playing {\n    background: var(--f0fdfa-background);\n    color: var(--059669-background);\n}\n\n.timerDisplay.paused {\n    background: var(--fef2f2-background);\n    color: var(--dc2626-color);\n}\n\n.timeHour {\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.month{\n    display: flex;\n    flex:1  \n}\n\n\n\n\n@media (max-width: 1000px) {\n    .mainGrid {\n        padding: 10px;\n    }\n    .chartHeader {\n        flex-direction: column;\n        gap: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rightPanel": `rightPanel_Xg6wL`,
	"chartCard": `chartCard_yX9ZC`,
	"chartHeader": `chartHeader_x_Jkr`,
	"chartTitle": `chartTitle_ajMyQ`,
	"chartSubtitle": `chartSubtitle_tIJN6`,
	"active": `active_GZD2v`,
	"chartControls": `chartControls_diT4j`,
	"chartValue": `chartValue_zy07L`,
	"barChart": `barChart_E90x0`,
	"bar": `bar_Ilctk`,
	"chartLabels": `chartLabels_yTwfA`,
	"sectionHeader": `sectionHeader_M0KIS`,
	"newPanelBtn": `newPanelBtn_migqH`,
	"chatPanel": `chatPanel_s68kQ`,
	"chatDescription": `chatDescription_Mo0Dc`,
	"chatButton": `chatButton_aDjSL`,
	"mediaControls": `mediaControls_hchKr`,
	"mediaBtn": `mediaBtn_FA_rN`,
	"pause": `pause_uNUyZ`,
	"play": `play_lBvic`,
	"stop": `stop_OMxTu`,
	"timerDisplay": `timerDisplay_uuXb7`,
	"playing": `playing_roalm`,
	"paused": `paused_R7jx7`,
	"timeHour": `timeHour_KHTY8`,
	"month": `month_HDCq1`,
	"mainGrid": `mainGrid_ieQGf`
};
export default ___CSS_LOADER_EXPORT___;
